import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import { ResponseError } from '../../utils/errors';
import {
  fetchSearchDevelopers,
  TQueryParameters,
  TSearchDevelopersResponse,
} from '../../repositories/developer-card/v1/search-developers';
import { ISearchDevelopersResponse } from '../../repositories/developer-card/entities/search_developers/SearchDevelopersResponse';

interface IParams {
  httpApi: IHttpApi;
  logger: ILogger;
  parameters: {
    page?: number;
    regionId?: number;
    searchText?: string;
    sort?: TQueryParameters;
    subdomain: string;
  };
}

export async function getBuildersInfo({ httpApi, logger, parameters }: IParams): Promise<ISearchDevelopersResponse> {
  try {
    const result: TSearchDevelopersResponse = await fetchSearchDevelopers({
      httpApi,
      parameters,
    });

    if (result.statusCode !== 200) {
      const { errors, message } = result.response;

      throw new ResponseError({
        message: message || 'Некорректный статус ответа',
        domain: 'services.fetchBuilders',
        details: { errors: JSON.stringify(errors) },
      });
    }

    return result.response;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
